import { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SwissIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 28 28" fill="none" {...props}>
            <rect width="28" height="28" rx="2" fill="#FF0000" />
            <path
                d="M12.1992 5.35547V12.1155H5.40039V16.7955H12.1992V23.5555H16.8015V16.7955H23.6004V12.1155H16.8015V5.35547H12.1992Z"
                fill="white"
            />
        </SvgIcon>
    );
};
